<template>
  <qx-card title="列表">
    <LogRightDialog ref="logRightDialog" busiCode="220000481" />

    <section slot="titleRight">
      <qx-permpisions permpisions="70001005">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="violationBO.ajax?cmd=doQueryNew"
          :params="fullSearchData"
          bizName="车辆违章台账导出"
          bizCode="exp12000"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="70001004">
        <ImportBtn
          title="车辆违章台账导入"
          bizCodes="imp1000108"
          :isDownloadLocalTemplate="true"
          fileUrl="/file/违章台账导入模板.xlsx"
          type="getImportTempFile"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="70001001">
        <el-button type="primary" plain @click="() => toEdit(null, 'add')">
          <i class="iconfont">&#xe6ab;</i>新增
        </el-button>
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section
                  v-if="scope.column.property === 'busiCode'"
                  @click="toBusiCodeDetail(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <section v-else>
                  <span>{{ scope.row[scope.column.property] }}</span>
                </section>
              </section>
            </el-table-column>
          </template>
          <el-table-column
            prop="control"
            label="操作"
            fixed="right"
            width="140"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :isCenter="true"
                :btnList="[
                  {
                    permpisions: '70001002',
                    showCondition: true,
                    name: '修改',
                    event: () => toEdit(scope.row, 'edit'),
                  },
                  {
                    permpisions: '70001003',
                    showCondition: !scope.row.busiCode,
                    name: '取消',
                    event: () => toCancel(scope.row),
                  },
                  {
                    showCondition: true,
                    name: '查看',
                    event: () => toEdit(scope.row, 'detail'),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.recordId),
                  },
                ]"
              />
            </template>
          </el-table-column>
        </el-table>
      </section>
      <section class="paginationBox clearPa">
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
      </section>
    </section>
  </qx-card>
</template>
<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import ImportBtn from 'components/importBtn';
import LogRightDialog from 'components/logRightDialog';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  doQueryNew,
  doCancel,
} from 'api/car';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    ImportBtn,
    LogRightDialog,
    TableBtn,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'plateNumber', label: '车牌号码', fixed: true },
          { prop: 'orgName', label: '归属部门' },
          { prop: 'categoryIdName', label: '违章类型' },
          { prop: 'violationTime', label: '违章时间' },
          { prop: 'locationName', label: '违章城市' },
          { prop: 'violationAddress', label: '违章地点' },
          { prop: 'violationCode', label: '违章代码' },
          { prop: 'violationPoint', label: '扣分数' },
          { prop: 'violationFine', label: '罚金(元)' },
          { prop: 'overdueFine', label: '滞纳金(元)' },
          { prop: 'payAmt', label: '成交价(元)' },
          { prop: 'serviceProvider', label: '服务商' },
          { prop: 'violationReason', label: '违章行为' },
          { prop: 'personLiable', label: '责任人' },
          { prop: 'recordStateName', label: '是否已处理' },
          { prop: 'createDate', label: '创建时间' },
          { prop: 'updateDate', label: '修改时间' },
          { prop: 'busiCode', label: '申请单号' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: doQueryNew,
    toBusiCodeDetail (item) {
      this.jump({
        label: '车辆费用',
        url: `/manage/cost/car/car?busiCode=${item.busiCode}`,
        full: true,
      });
    },
    async toCancel (item) {
      const confirmRes = await this.$confirm('是否确定取消申请？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        await doCancel({ recordId: item.recordId });
        this.getData();
      }
    },
    toEdit (item, type) {
      switch (type) {
        case 'add':
          this.jump({
            label: '新增违章详情',
            url: '/manage/car/maintain/violation/edit',
            full: true,
          });
          break;
        case 'detail':
          this.jump({
            label: '查看违章详情',
            url: `/manage/car/maintain/violation/detail?id=${item.recordId}&type=detail`,
            full: true,
          });
          break;
        case 'edit':
          this.jump({
            label: '修改违章详情',
            url: `/manage/car/maintain/violation/edit?id=${item.recordId}`,
            full: true,
          });
          break;
        default:
          break;
      }
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
